import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { CustomDetailComponent } from '@vendure/admin-ui/core';
import { Observable } from 'rxjs';

@Component({
  standalone: false,
    selector: 'customer-detail-patcher',
    template: ``,
})
export class CustomerDetailPatcherComponent
    implements AfterViewInit, OnDestroy, CustomDetailComponent
{
    entity$: Observable<any>;
    detailForm: any;
    private mutationObserver?: MutationObserver;

    ngAfterViewInit() {
        this.applyCustomizations();
    }

    ngOnDestroy() {
        if (this.mutationObserver) {
            this.mutationObserver.disconnect();
        }
    }

    private applyCustomizations() {
        const patchUI = () => {
            this.disableAddToGroupButton();
            this.disableRemoveGroupButtons();
            this.disableEditFieldButtons();
            this.disableAddressButtons();
            this.translateChipLabels();
        };

        // Executa uma vez ao entrar na tela
        patchUI();

        // Observa mudanças no DOM
        this.mutationObserver = new MutationObserver(() => patchUI());
        this.mutationObserver.observe(document.body, {
            childList: true,
            subtree: true,
        });
    }

    /** Busca um card pelo texto do título interno */
    private findCardByTitle(title: string): HTMLElement | null {
        return (
            (Array.from(document.querySelectorAll('vdr-card')).find((card) => {
                const spanTitle = card.querySelector('.title');
                return spanTitle?.textContent?.trim() === title;
            }) as HTMLElement) || null
        );
    }

    /** Desabilita botão "Adicionar cliente ao grupo" */
    private disableAddToGroupButton() {
        const card = this.findCardByTitle('Grupos de cliente');
        const button = card?.querySelector(
            'button.button-small'
        ) as HTMLButtonElement;
        if (button) this.disableButton(button);
    }

    /** Desabilita botão "x" para remover grupos */
    private disableRemoveGroupButtons() {
        const card = this.findCardByTitle('Grupos de cliente');
        card
            ?.querySelectorAll('vdr-chip .chip-icon button')
            .forEach((btn) => this.disableButton(btn as HTMLButtonElement));
    }

    /** Desabilita botões de edição de campos (lápis) */
    // Voltar quando precisar desabilitar o email
    // private disableEditFieldButtons() {
    //     document
    //         .querySelectorAll('.input-row.has-toggle button.edit-button')
    //         .forEach((btn) => this.disableButton(btn as HTMLButtonElement));
    // }

    private disableEditFieldButtons() {
        document
            .querySelectorAll('.input-row.has-toggle button.edit-button')
            .forEach((btn) => {
                const inputId = (
                    btn
                        .closest('.input-row')
                        ?.querySelector('input') as HTMLInputElement
                )?.id;
                if (inputId !== 'emailAddress') {
                    this.disableButton(btn as HTMLButtonElement);
                }
            });
    }

    /** Desabilita todos os botões da seção "Endereços" */
    private disableAddressButtons() {
        const card = this.findCardByTitle('Endereços');
        card
            ?.querySelectorAll('button')
            .forEach((btn) => this.disableButton(btn as HTMLButtonElement));
    }

    /** Helper para desabilitar botões com estilo */
    private disableButton(button: HTMLButtonElement) {
        button.disabled = true;
        button.style.opacity = '0.5';
        button.style.cursor = 'not-allowed';
        button.style.pointerEvents = 'none';
    }

    /** Tradução dos chips de grupos */
    private translateChipLabels() {
        document.querySelectorAll('vdr-chip .chip-label').forEach((el) => {
            const text = el.textContent?.trim();
            if (text === 'under_analysis') el.textContent = 'Em análise';
            if (text === 'approved') el.textContent = 'Aprovado';
            if (text === 'disapproved') el.textContent = 'Reprovado';
        });
    }
}
